/**
 * ConnectionLine 组件
 * 使用 CSS border 方案渲染 StudioCard 与地图 Icon 之间的连接线
 */

import React from 'react';
import { EChartsType } from 'echarts';
import useConnectionLineStyles from '../../hooks/useConnectionLineStyles';
import { IStudio } from '../../const/studio';
import './index.scss';

interface IConnectionLineProps {
  visible: boolean;
  hoveredStudioName: string | string[] | null;
  containerRef: React.RefObject<HTMLDivElement>;
  chartRef: React.RefObject<HTMLDivElement>;
  cardRefsMap: React.RefObject<Map<string, HTMLDivElement>>;
  chartInstance: EChartsType | undefined | null;
  studios?: IStudio[];
}

/**
 * 连接线组件
 * 使用透明 div + CSS border 实现 L 型折线圆角效果
 */
const ConnectionLine: React.FC<IConnectionLineProps> = ({
  visible,
  hoveredStudioName,
  containerRef,
  chartRef,
  cardRefsMap,
  chartInstance,
  studios = [],
}) => {
  const connectionLineStyles = useConnectionLineStyles({
    visible,
    hoveredStudioName,
    containerRef,
    chartRef,
    cardRefsMap,
    chartInstance,
    studios,
  });

  if (!visible || connectionLineStyles.length === 0) {
    return null;
  }

  return (
    <>
      {connectionLineStyles.map(({ studioName, style }) => (
        <div
          key={`connection-line-${studioName}`}
          className="dbd-connection-line"
          style={{
            left: `${style.left}px`,
            top: `${style.top}px`,
            width: `${style.width}px`,
            height: `${style.height}px`,
            borderTop: style.borderTop,
            borderRight: style.borderRight,
            borderBottom: style.borderBottom,
            borderLeft: style.borderLeft,
            borderRadius: style.borderRadius,
            opacity: 1,
          }}
        />
      ))}
    </>
  );
};

export default React.memo(ConnectionLine);
